import React from 'react'
import { Button } from '~/components/_atoms/index'
import Modal from '~/components/_layouts/Modal/index'
import SavedStatusIcon from '~/components/shared/SavedStatusIcon'
import { useTranslation } from '~/hooks/useTranslation'

export const NoDocumentAlert = ({
  showAlertDialog,
  onConfirm,
  onClose,
  loading,
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={showAlertDialog}
      onClose={onClose}
      title={t('ConfirmSubmitDialog.title')}
      size="md"
      actions={[
        <Button onClick={onClose} key="cancel" variant="ghost">
          {t('ConfirmSubmitDialog.cancel')}
        </Button>,
        <Button key="confirm" onClick={onConfirm} disabled={loading}>
          {!loading && t('ConfirmSubmitDialog.confirm')}
          <SavedStatusIcon loadingStatus={loading ? t('loading') : null} />
        </Button>,
      ]}
    >
      <div>{t('ConfirmSubmitDialog.description')}</div>
    </Modal>
  )
}
